import React from "react";
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: "bold",
    verticalAlign: "top",
  },
  container: {
    minWidth: "70%",
  },
}));

function DeliveryDetails(props) {
  const classes = useStyles();

  const { delivery } = props;

  return (
    <div className={classes.container}>
      <h2 id="transition-modal-title">Delivery Details</h2>
      <p id="transition-modal-description">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableBody>
              <TableRow>
                <TableCell className={classes.label}>Order ID</TableCell>
                <TableCell>{delivery?.orderId}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.label}>Name</TableCell>
                <TableCell>{delivery?.name}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.label}>Mobile Number</TableCell>
                <TableCell>{delivery?.mobileNumber}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.label}>Address</TableCell>
                <TableCell>{delivery?.address}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.label}>Landmark</TableCell>
                <TableCell>{delivery?.landmark}</TableCell>
              </TableRow>
              {delivery?.lastDirections?.routes[0]?.legs[0]?.duration?.text && (
                <TableRow>
                  <TableCell className={classes.label}>ETA</TableCell>
                  <TableCell>
                    {delivery.lastDirections.routes[0].legs[0].duration.text}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </p>
    </div>
  );
}

export default DeliveryDetails;
